import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ThemePalette, ThemeSize } from '@ngx-simple/core/common-behaviors';
import { SimPaginatorComponent } from '@ngx-simple/simple-ui/paginator';
import { SimSortDirective } from '@ngx-simple/simple-ui/sort';
import { SimTableComponent } from './table.component';

@Component({
  selector: 'sim-table-data',
  templateUrl: './table-data.component.html',
  styleUrls: ['./table-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sim-table-data'
  }
})
export class SimTableDataComponent<T> implements OnInit, AfterContentInit, AfterViewInit {
  @Input() color: ThemePalette = 'primary';
  @Input() size: ThemeSize = 'medium';

  @Input()
  get dataSource() {
    return this._dataSource;
  }
  set dataSource(value: any) {
    if (this._dataSource !== value) {
      this._dataSource = value;
    }
  }
  private _dataSource: T[];

  @ViewChild(SimPaginatorComponent) paginator: SimPaginatorComponent;

  @ContentChild(SimSortDirective, { static: true }) sort: SimSortDirective;
  @ContentChild(SimTableComponent, { static: true }) table: SimTableComponent<T>;

  constructor() {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    this.table.dataSource = this.dataSource;
    this.table.color = this.color;
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      Promise.resolve().then(() => {
        this.dataSource.paginator = this.paginator;
      });
    }
  }
}
